<template>
    <div>
        <div class="badgesOrder">
            <div class="badgeOrder" v-for="(badge, index) in badges">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][firstname]'">
                                <slot name="firstname-label"></slot>
                            </label>
                            <input
                                type="text"
                                :name="'badges[' + index + '][firstname]'"
                                :disabled="viewOnly"
                                v-model="badge.firstname"
                                @keydown.enter.prevent
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][lastname]'">
                                <slot name="lastname-label"></slot>
                            </label>
                            <input
                                type="text"
                                :name="'badges[' + index + '][lastname]'"
                                :disabled="viewOnly"
                                v-model="badge.lastname"
                                @keydown.enter.prevent
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][position]'">
                                <slot name="position-label"></slot>
                            </label>
                            <input
                                type="text"
                                :name="'badges[' + index + '][position]'"
                                :disabled="viewOnly"
                                v-model="badge.position"
                                @keydown.enter.prevent
                            >
                        </div>
                    </div>

                    <div class="col-md-2" v-if="showActivity">
                        <div class="form-group">
                            <label :for="'badges[' + index + '][subscription]'">
                                <slot name="module-label"></slot>
                            </label>
                            <div class="input-group input-group--append">
                                <select :name="'badges[' + index + '][subscription]'" v-model="badge.subscription" :disabled="viewOnly" @keydown.enter.prevent>
                                    <option :selected="badge.subscription == 0"></option>
                                    <option v-for="(opt, key) in options" :value="opt.id" :selected="badge.subscription == opt.id">{{ opt.name }}</option>
                                </select>
                                <div class="input-group__icon">
                                    <svg viewBox="0 0 24 24">
                                        <use xlink:href="#chevron-down"></use>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-1 badgeOrder__actions" v-if="! viewOnly">
                        <button type="button" class="btn-medium-grey badgeOrder__delete" @click="deleteBadge(index)">
                            <slot name="delete-label"></slot>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="badgesOrder--addBadge" v-if="! viewOnly">
            <button type="button" class="btn-blue" @click="addBadge">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            oldBadges: {
                type: Array,
                firstname: String,
                lastname: String,
                position: String,
                subscription: String,
                default: () => [
                    {
                        firstname: '',
                        lastname: '',
                        position: '',
                        subscription: 0
                    }
                ]
            },
            subscriptions: {
                type: Array,
                default: () => []
            },
            showActivity: {
                type: Boolean,
                default: false
            },
            viewOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                badges: this.oldBadges,
                options: this.subscriptions

            }
        },
        methods: {
            addBadge() {
                this.badges.push({
                    firstname: '',
                    lastname: '',
                    position: '',
                    subscription: 0
                });
            },
            deleteBadge(badgeIndex) {
                this.badges.splice(badgeIndex, 1);
                if (this.badges.length === 0) {
                    this.addBadge();
                }
            }
        }
    }
</script>
